import { useEffect, useLayoutEffect, useRef } from "react";

type FullscreenProgressProps = {
  visible: boolean;
  message?: string;
  modal?: boolean;
};

export function FullscreenProgress({ visible, message, modal = false }: FullscreenProgressProps) {
  const dialog = useRef<HTMLDialogElement>(null);
  useLayoutEffect(() => {
    const element = dialog.current;
    if (!visible || !modal || !element) return;
    const previousFocus = document.activeElement;
    element.showModal();
    return () => {
      element.close();
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, [visible, modal]);
  useEffect(() => {
    if (!visible || modal) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [visible, modal]);

  if (!visible) return null;

  const content = <div className="fullscreen-progress-content" role="progressbar" aria-label={message || "Yükleniyor"}>
        <span className="fullscreen-progress-indicator" aria-hidden="true" />
        <strong role="status">{message || "İşlem sürüyor…"}</strong>
      </div>;
  return modal
    ? <dialog ref={dialog} className="fullscreen-progress" aria-label={message || "İşlem sürüyor"} tabIndex={-1} onCancel={event => event.preventDefault()}>{content}</dialog>
    : <div className="fullscreen-progress">{content}</div>;
}
